import { siteAPIURL } from "@/utilities/constants";
import { readPlanResponse, type PlanRequest } from "@/utilities/signup-lookup";

export async function getPlans(input: PlanRequest, signal?: AbortSignal) {
	const response = await fetch(siteAPIURL + "/signup/get-plans", {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(input),
		cache: "no-store",
		signal,
	});
	return readPlanResponse(response);
}
